import { ModalContainer } from "@kanda-libs/ks-component-ts";
import type { FunctionComponent } from "react";
import CompanyVerifyModalForm from "components/company/CompanyVerifyModal/CompanyVerifyModalForm";
import { MODAL_ID } from "components/company/CompanyVerifyModal/constants";

export interface CompanyVerifyModalProps {}

const CompanyDeclineModal: FunctionComponent<CompanyVerifyModalProps> =
  function () {
    return (
      <ModalContainer id={MODAL_ID} opacity={30}>
        {({ handleClose, ref }) => (
          <CompanyVerifyModalForm handleClose={handleClose} ref={ref} />
        )}
      </ModalContainer>
    );
  };

export default CompanyDeclineModal;
